import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import useState from "react-usestateref";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { getReferredUserDeposits, getUserDetails, getAssets, getTeamHistory } from "../services/authservices"
import { ScaleLoader } from 'react-spinners'

function Team() {
  const [user, setUser] = useState({
    tfaStatus: 0,
    email: null,
    uid: null,
    referralCode: null,
    referralUrl: null,
    botStatus: "DeActive",
    displayname: null,
    referralCount: 0,
    directReferralCount: 0,
    indirectReferralCount: 0,
    profits: 0,
    country: null,
    isAuthenticated: false,
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const fetchUserDetails = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const data = await getUserDetails(token);
        if (data && data.status) {
          const userDetails = {
            isAuthenticated: true,
            tfaStatus: data.tfastatus,
            email: data.email,
            displayname: data.displayname,
            country: data.country,
            uid: data.uid,
            referralCode: data.referralCode,
            referralUrl: data.referralUrl,
            referralCount: data.referralCount,
            directReferralCount: data.directReferralCount,
            indirectReferralCount: data.indirectReferralCount,
            botStatus: data.botStatus,
            profits: data.profits
          };
          setUser(userDetails);
        } else {
          setUser({
            isAuthenticated: false,
            tfaStatus: 0,
            email: null,
            uid: null,
            referralCode: null,
            referralUrl: null,
            referralCount: 0,
            directReferralCount: 0,
            indirectReferralCount: 0,
            profits: 0,
          });
        }
      } catch (error) {
        setUser({
          isAuthenticated: false,
          tfaStatus: 0,
          email: null,
          uid: null,
          referralCode: null,
          referralUrl: null,
          referralCount: 0,
          directReferralCount: 0,
          indirectReferralCount: 0,
          profits: 0,
        });
      }
    } else {
      setUser({
        isAuthenticated: false,
        tfaStatus: 0,
        email: null,
        uid: null,
        referralCode: null,
        referralUrl: null,
        referralCount: 0,
        directReferralCount: 0,
        indirectReferralCount: 0,
        profits: 0,
      });
    }
    setLoading(false);
  };
  const [teamData, setTeamData] = useState({
    totalTeamAUM: 0,
    directMemberAUM: 0,
    indirectMemberAUM: 0,
  });

  const [profitData, setProfitdata] = useState(null);
  const [referralHistory, setReferralHistory] = useState([]);
  const [historyloading, sethistoryLoading] = useState(true);
  const [page, setpage] = useState(1);
  const [limit, setlimit] = useState(5);
  const [filters, setfilters] = useState({});

  const fetchReferredUserDeposits = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const data = await getReferredUserDeposits(token);
      if (data) {
        setTeamData({
          totalTeamAUM: data.totalDeposits || 0,
          directMemberAUM: data.directDeposits || 0,
          indirectMemberAUM: data.indirectDeposits || 0,

        });
      }
    } catch (error) {
      console.error("Error fetching referred user deposits:", error);
    }
  };

   const fetchAssets = async () => {
        try {
          const response = await getAssets();
          if (response.status === true) {
            setProfitdata(response?.profits)
          } else {
            console.error("Unexpected response format:", response);
          }
        } catch (error) {
          console.error("Error fetching transactions:", error);
        }
      };
  useEffect(() => {
    fetchReferredUserDeposits();
  }, [0]);

  useEffect(() => {
    fetchUserDetails();
    fetchAssets();
    fetchReferralHistory();

  }, [0]);

   const fetchReferralHistory = async () => {
      try {
        sethistoryLoading(true);
        const data = await getTeamHistory(filters,page,limit);
        console.log("team history====",data);
        if (data && data.status && Array.isArray(data.referralHistory)) {
          setReferralHistory(data.referralHistory);
          sethistoryLoading(false);
        } else {
          setReferralHistory([]);
          sethistoryLoading(false)
        }
      } catch (error) {
        console.error("Error fetching referral history:", error);
        setReferralHistory([]);
        sethistoryLoading(false)
      }
    };
  return (
    <div>
      <section>
        <Header />
      </section>

      <div className="team-section">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-2 dispaly_none_1200">
              <Sidebar />
            </div>

            <div className="col-xl-10 col-lg-12 deposit_pad_top">
            {loading ? (
                  <div className="loader_main loader_mainChange">
                      <ScaleLoader color="#20A1FD" height={10} width={3} />
                      <p>Loading...</p>
                  </div>
              ) : (
                <>
                <div className="row team_main">
                <div className="col-lg-4 team_left_col_top">
                  <span className="team_top_left">Manage Your Team</span>
                </div>
                <div className="col-lg-8 m-top-20 pad_team_460">
                  <div className="team_top_right">
                    <div className="team_top_right_inmain">
                      <div className="team_top_right_leftcolor"></div>
                      <div className="team_topright_inner">
                        <span className="team_topinner_head">Team Members</span>
                        {user.referralCount != null && user.referralCount != undefined ? (
                        <span className="team_topinner_subhead">{user.referralCount}</span>
                        ) : (
                          <span className="team_topinner_subhead">0</span>
                        )}
                      </div>
                    </div>
                    <div className="team_top_right_inmain">
                      <div className="team_top_right_leftcolor"></div>
                      <div className="team_topright_inner">
                        <span className="team_topinner_head">
                          Cumulative profit (USDT)
                        </span>
                        <span className="team_topinner_subhead">{((profitData?.overallProfit) ? profitData?.overallProfit : '0.00')}</span>
                      </div>
                    </div>
                    <div className="team_top_right_inmain">
                      <div className="team_top_right_leftcolor"></div>
                      <div className="team_topright_inner">
                        <span className="team_topinner_head">
                          Direct members
                        </span>
                        {user.directReferralCount != null && user.directReferralCount != undefined ? (
                        <span className="team_topinner_subhead">{user.directReferralCount}</span>
                        ) : (
                          <span className="team_topinner_subhead">0</span>
                        )}
                      </div>
                    </div>
                    <div className="team_top_right_inmain">
                      <div className="team_top_right_leftcolor"></div>
                      <div className="team_topright_inner">
                        <span className="team_topinner_head">
                          Indirect members
                        </span>
                        {user.indirectReferralCount != null && user.indirectReferralCount != undefined ? (
                        <span className="team_topinner_subhead">{user.indirectReferralCount}</span>
                        ) : (
                          <span className="team_topinner_subhead">0</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="team_second_main">
                <div className="row ">
                  <div className="col-lg-4 pad-0-560">
                    <div className="team_secondin_box">
                      <div className="team_secondin_box_head">
                        <img
                          src={require("../assests/icons/refer-teamember.png")}
                          alt="Refer"
                          className="refer_icon_inbox icons-light"
                        />
                        <img
                          src={require("../assests/icons/refer-teamember-dark.webp")}
                          alt="Refer"
                          className="refer_icon_inbox icons-dark"
                        />
                        <span className="top_startgy_inbottomadvance">
                          {" "}
                          Total Team AUM
                        </span>
                      </div>
                      {teamData.totalTeamAUM != null && teamData.totalTeamAUM != undefined ? (
                      <span className="refer_count_number">{teamData.totalTeamAUM.toFixed(2)} USDT</span>
                      ) : (
                        <span className="refer_count_number">0.00 USDT</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 pad-0-560 m-top-20">
                    <div className="team_secondin_box">
                      <div className="team_secondin_box_head">
                        <img
                          src={require("../assests/icons/refer-teamember.png")}
                          alt="Refer"
                          className="refer_icon_inbox icons-light"
                        />{" "}
                        <img
                          src={require("../assests/icons/refer-teamember-dark.webp")}
                          alt="Refer"
                          className="refer_icon_inbox icons-dark"
                        />
                        <span className="top_startgy_inbottomadvance">
                          {" "}
                          Direct Member AUM
                        </span>
                      </div>
                      {teamData.directMemberAUM != null && teamData.directMemberAUM != undefined ? (
                      <span className="refer_count_number">{teamData.directMemberAUM.toFixed(2)} USDT</span>
                      ) : (
                        <span className="refer_count_number">0.00 USDT</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 pad-0-560 m-top-20">
                    <div className="team_secondin_box">
                      <div className="team_secondin_box_head">
                        <img
                          src={require("../assests/icons/refer-teamember.png")}
                          alt="Refer"
                          className="refer_icon_inbox icons-light"
                        />{" "}
                        <img
                          src={require("../assests/icons/refer-teamember-dark.webp")}
                          alt="Refer"
                          className="refer_icon_inbox icons-dark"
                        />
                        <span className="top_startgy_inbottomadvance">
                          {" "}
                          Indirect Members AUM
                        </span>
                      </div>
                      {teamData.indirectMemberAUM != null && teamData.indirectMemberAUM != undefined ? (
                      <span className="refer_count_number">{teamData.indirectMemberAUM.toFixed(2)} USDT</span>
                      ) : (
                        <span className="refer_count_number">0.00 USDT</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
                </>
              )}

                <div className="row mb-4">
                            <div className="col-lg-12 p-0">
                              <div className="refer_third_main pb-0">
                                <div className="manage_btn_row">
                                  <span className="home_botstatus_span">Recent Team History</span>
                                  <Link to="/teamhistory">
                                    <div className="d-flex align-items-center gap-2 cursor-pointer">
                                      <span className="home_starty_view">View All</span>
                                      <i class="fa-solid fa-chevron-right home_starty_viewarrow"></i>
                                    </div>
                                  </Link>
                                </div>
                                
                                <div className="new_referdesi_chn">
                                <div className="table-responsive table-borderless home_recent_table">
                                  {historyloading ? (
                                     <div className="loader_main loader_mainChange">
                                      <ScaleLoader color="#20A1FD" height={10} width={3} />
                                      <p>Loading...</p>
                                    </div>
                                  ) : (
                                    <>
                                    <table className="table">
                                      <thead>
                                        <tr>
                                          <th >SI.no</th>
                                          <th>Name</th>
                                          <th>UserID</th>
                                          <th>Tier</th>
                                          <th>Fuel Balance</th>
                                          <th>Bot Status</th>
                                          <th>Cumulative Profit</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {referralHistory.length > 0 ? (
                                          referralHistory.slice(0, 5).map((referral, index) => (
                                            <tr key={referral.uuid}>
                                              {/* <td className="text_left"> */}
                                              <td>
                                                <span>{index + 1}</span>
                                              </td>
                                              <td>
                                                <span>{referral.displayname}</span>
                                              </td>
                                              <td>
                                                <span>{referral.referralCode}</span>
                                              </td>
                                              <td>
                                                <span>{referral.tier.toUpperCase()}</span>
                                              </td>
                                              <td>
                                                <span>{referral.fuel_balance}</span>
                                              </td>
                                              <td>
                                                <span>{referral.botStatus}</span>
                                              </td>
                                              <td>
                                                <span>{referral.overallProfit}</span>
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="7" className="text-center">
                                              <span className="depo_no_record">
                                                No team history available.
                                              </span>
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
              
                                    </>
                                    
                                  )}
                                </div>
                                </div>
                              </div>
                            </div>
                          </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Team;
